import { setCookie } from "../helpers/cookie";

export class privacyAlert {
	acceptButton: HTMLElement;
	container: HTMLElement;

	constructor(container: HTMLElement) {
		this.container = container;
		this.acceptButton = container.querySelector('[data-privacy-accept]');
		this.initListeners();
	}

	initListeners() {

		this.acceptButton.addEventListener('click', () => {
			this.hideAlert();
			setCookie('SFJAZZ_Cookie_Accepted', 'True', 365);
		});

	}

	hideAlert() {
		this.container.classList.add('hidden');
	}
}